const billing = {
  pageTitle: 'Payments & Invoices',
  pageDescription: 'Your payment history and tax invoices - view, download, or print any invoice.',
  backToAccount: 'Back to account',

  invoices: {
    title: 'Invoices',
    description: 'Every purchase produces one itemized tax invoice (15% VAT).',
    invoice: 'Invoice',
    date: 'Date',
    items: 'Items',
    total: 'Total',
    status: 'Status',
    actions: 'Actions',
    view: 'View',
    download: 'PDF',
    moreItems: '+{{count}} more',
    empty: 'No invoices yet',
    emptyDescription: 'Once you subscribe or buy an add-on, your invoices will appear here.',
    loadError: 'Could not load your invoices.',
    retry: 'Retry',
    pdfFallback: 'Opened a printable invoice - use your browser to save it as PDF.',
    pdfError: 'Could not open the invoice.',
    page: 'Page {{page}} of {{total}}',
    prev: 'Previous',
    next: 'Next',
  },

  status: {
    ISSUED: 'Issued',
    PAID: 'Paid',
    REFUNDED: 'Refunded',
    PARTIALLY_REFUNDED: 'Partly refunded',
    CANCELLED: 'Cancelled',
  },

  subscription: {
    title: 'Subscription',
    plan: 'Plan',
    status: 'Status',
    nextRenewal: 'Next renewal',
    autoRenew: 'Auto-renew',
    autoRenewPending: 'Auto-renew turns on once card-on-file billing is live. For now, renew manually before the date above.',
    renewNow: 'Renew now',
    manage: 'Manage plan',
    none: 'No active subscription',
    noneDescription: 'Subscribe to unlock advertiser features.',
    browsePlans: 'Browse plans',
    saved: 'Auto-renew updated',
    saveError: 'Could not update auto-renew.',
    cycleMonthly: 'Monthly',
    cycleYearly: 'Yearly',
    statusValues: { ACTIVE: 'Active', PAST_DUE: 'Past due', EXPIRED: 'Expired', CANCELLED: 'Cancelled' },
  },

  profile: {
    title: 'Billing details',
    description: 'Used on your tax invoices. Add your VAT/CR details for a business (B2B) tax invoice.',
    legalName: 'Legal / display name',
    buyerType: 'Account type',
    individual: 'Individual',
    company: 'Business',
    vatNumber: 'VAT number',
    crNumber: 'Commercial registration (CR)',
    address: 'Billing address',
    billingEmail: 'Billing email',
    save: 'Save details',
    saved: 'Billing details saved',
    saveError: 'Could not save your billing details.',
    b2bNote: 'A VAT number turns your invoices into Standard Tax Invoices (B2B).',
    optional: 'optional',
  },
};

export default billing;
